import { render, staticRenderFns } from "./upload-model.vue?vue&type=template&id=a3c09f92&scoped=true&"
import script from "./upload-model.vue?vue&type=script&lang=ts&"
export * from "./upload-model.vue?vue&type=script&lang=ts&"
import style0 from "./upload-model.vue?vue&type=style&index=0&id=a3c09f92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c09f92",
  null
  
)

export default component.exports